import { render, staticRenderFns } from "./AdminItemContainer.vue?vue&type=template&id=4700849e&scoped=true&"
import script from "./AdminItemContainer.vue?vue&type=script&lang=js&"
export * from "./AdminItemContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700849e",
  null
  
)

export default component.exports